export default __webpack_public_path__ + "static/media/black-line.59abc549.png";